export default "__VITE_ASSET__CDfzXkbf__"